var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestmentStratergyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#B7D9B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5996_20013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.07 10.93L23.66 12.34C25.1 13.79 26 15.79 26 18C26 22.42 22.42 26 18 26C13.58 26 10 22.42 10 18C10 13.92 13.05 10.56 17 10.07V12.09C14.16 12.57 12 15.03 12 18C12 21.31 14.69 24 18 24C21.31 24 24 21.31 24 18C24 16.34 23.33 14.84 22.24 13.76L20.83 15.17C21.55 15.9 22 16.9 22 18C22 20.21 20.21 22 18 22C15.79 22 14 20.21 14 18C14 16.14 15.28 14.59 17 14.14V16.28C16.4 16.63 16 17.26 16 18C16 19.1 16.9 20 18 20C19.1 20 20 19.1 20 18C20 17.26 19.6 16.62 19 16.28V8H18C12.48 8 8 12.48 8 18C8 23.52 12.48 28 18 28C23.52 28 28 23.52 28 18C28 15.24 26.88 12.74 25.07 10.93Z",
    fill: "#0C4A0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5996_20013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentStratergyIcon);
export default __webpack_public_path__ + "static/media/InvestmentStratergyIcon.aacc2d8db72f8c66fe697743bf138e9e.svg";
export { ForwardRef as ReactComponent };